<template>
  <div class="auth">
    <!--    <h3>Авторизация</h3>-->
    <div v-if="errors.length">
      <div v-for="(error, key) in errors" :key="key" class="auth__alert">
        {{ error }}
      </div>
    </div>
    <div class="auth__btnBlock">
      <div class="auth__gosuslugi-btn" @click="esiaAuth">
        <div class="auth__gosuslugi-container">
          <img src="@/create/assets/icons/gosuslugi-login.svg" alt="gosuslugi">
          <span class="auth__gosuslugi-text">Войти через Госуслуги</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {baseURL, esiaRedirectURL} from "@/create/composables/const";
import axios from "axios";

export default {
  name: "LoginComponent",
  props: ["errors"],
  data() {
    return {

    };
  },
  methods: {
    async esiaAuth() {
      try {
        const response = await axios.post(baseURL, {
          ver: 0,
          object: "contract",
          login: "ybrir",
          action: "landing_signer_esia_url",
          slug: this.$route.params.slugID,
          redirect_url: esiaRedirectURL + `/${this.$route.params.slugID}/`
        });
        if (response.data.uri) {
          window.open(response.data.uri, "_self");
        }
      } catch (e) {
        console.log("Frontend esiaAuth Error - " + e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.auth {
  width: 100%;
  max-width: 550px;
  padding: 2em;
  box-shadow: 0 0 0.9em 0.5em #bbb9b9;
  margin: 42vh auto;

  @media screen and (max-width: 450px) {
    max-height: 100vh;
    overflow: auto;
    max-width: unset;
    width: 95%;
  }

  .auth__btnBlock {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .auth__gosuslugi-btn {
      padding: 10px 12px;
      width: 100%;
      cursor: pointer;
      border: 1px solid #014b88;

      .auth__gosuslugi-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        img {
          margin-right: 10px;
        }

        span.auth__gosuslugi-text {
          font-weight: 600;
          font-size: 16px;
          line-height: 20px;
          color: #014b88;
          max-width: 185px;

          @media only screen and (max-width: 768px) {
            font-size: 14px;
            line-height: 16px;
          }
        }
      }
    }
  }

  .auth__alert {
    color: red;
    font-size: 11pt;
    font-weight: 600;
    margin-bottom: 10px;
  }
}
</style>
